import { Component, ContentChild, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output, Renderer2, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '../../utils/services/api.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserDropdownComponent),
      multi: true
    }
  ]
})
export class UserDropdownComponent implements OnInit, ControlValueAccessor {

  
  @Input() dropdownItemTemplate: TemplateRef<any>;
  @Input() dropdownButtonTemplate: TemplateRef<any>;
  @ViewChild("dropdownButton") dropdownButton: ElementRef;
  @ViewChild("searchInput") searchInput;
  @ViewChild("dropdownMenu") dropdownMenu;
  @ViewChildren("dropdownItem") dropdownItems;
  @Input() organizationId;
  @Input() singleSelect: boolean = false;
  @Input() searchable: boolean = true;
  @Input() setTheOnlyItemAsSelected: boolean = true;
  @Input() isClearable = true;
  private selectedIndex = 0;
  public visibleCount = 0;
  public searchInputControl = new FormControl();
  public dataList: Array<any>;
  public selectedDataList: Array<any> = [];

  @ContentChild("myelement") children;
  private keyEventSubject: Subject<string> = new Subject();

  @Input()
  selectedUsers: Array<any> = [];
  @Output()
  onUserSelected: EventEmitter<any> = new EventEmitter<any>();
  public searchParams: URLSearchParams = new URLSearchParams();
  public limit = 10;
  public propagateChange = (_: any) => { };


  @HostListener("window:click", ["$event"])
  clickHandler(event) {
    if (!(this.elementRef.nativeElement.contains(event.target))) {
      this.hideDropDown();
    }
  }


  constructor(private renderer: Renderer2, private apiService: ApiService,
    private elementRef: ElementRef) {
  }

  ngOnInit() {
    this.keyEventSubject.debounceTime(300).subscribe(event => {
      this.handleKeyDown(event);
    });

    this.searchParams.set('limit', this.limit.toString());
    this.searchParams.set('offset', '0');
    this.searchParams.set('sortBy', 'firstName');
    this.searchParams.set('sortType', 'ASC');
    this.searchInputControl.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value) {
        if (value.length > 0) {
          this.onSearchTextChanged(value);
        } else {
          this.onSearchTextChanged(null);
        }
      } else {
        this.onSearchTextChanged(null);
      }
    })
    this.fetchUsers();
  }

  fetchUsers() {
    this.apiService.getUsers(this.organizationId, this.searchParams).subscribe(res => {
      this.setMenuDataForInitialize(res.data.rows);
    }, err => {
      this.setMenuDataForInitialize([]);
    })
  }


  ngAfterViewInit() {

  }

  ngDoCheck() {
    if (this.dropdownButton && this.dropdownButton.nativeElement && this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0]) {
      this.visibleCount = Math.floor(this.dropdownButton.nativeElement.offsetWidth / this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0].offsetWidth) - 2;
    }
  }

  setSelectedData(selectedDataList: Array<any>) {
    if (Array.isArray(selectedDataList)) {
      this.selectedDataList = selectedDataList;
    } else {
      this.selectedDataList = [];
    }
  }

  setMenuDataForInitialize(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
      if (this.setTheOnlyItemAsSelected && (this.selectedDataList && this.selectedDataList.length == 0) && (this.dataList && this.dataList.length == 1)) {
        this.setSelectedData([...this.dataList]);
      }
    } else {
      this.dataList = [];
    }
  }

  setMenuDataForLoadMore(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
    } else {
      this.dataList = [];
    }
  }

  addMenuData(data) {
    this.dataList.push(data);
  }

  onDataPicked(data: any) {
    if (data) {

      if (this.singleSelect) {
        if (this.selectedDataList.length == 0) {
          this.selectedDataList[0] = data;
        } else {
          if (data['id'] === this.selectedDataList[0]['id']) {
            if (this.isClearable && this.selectedDataList.length > 0)
              this.selectedDataList.splice(0, 1);
          } else {
            this.selectedDataList[0] = data;
          }
        }

        this.onUserSelected.emit(this.selectedDataList);
        this.propagateChange(this.selectedDataList);
        this.hideDropDown();
      } else {
        var selectedIndex = this.selectedDataList.findIndex((element) => element['id'] === data['id']);
        if (selectedIndex > -1) {
          this.selectedDataList.splice(selectedIndex, 1);
        } else {
          this.selectedDataList.push(data);
        }
        this.onUserSelected.emit(this.selectedDataList);
        this.propagateChange(this.selectedDataList);
      }
    }

  }

  showDropDown() {
    this.renderer.addClass(this.dropdownMenu.nativeElement, "show");
    if (this.dropdownItems.toArray()[this.selectedIndex]) {
      this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
    }
    if (this.searchable) {
      this.searchInput.nativeElement.click();
      this.searchInput.nativeElement.focus();
    }

  }

  hideDropDown() {
    this.renderer.removeClass(this.dropdownMenu.nativeElement, "show");
  }

  toggleDropdownMenu() {
    if (this.dropdownMenu.nativeElement.classList.contains("show")) {
      this.hideDropDown();
    }
    else {
      this.renderer.removeClass(this.dropdownMenu.nativeElement, "hide");
      this.showDropDown();
    }
  }

  keyDown(event) {
    //event.preventDefault();
    //40 down
    //38 UP
    //27 Escape
    //13 Enter
    //this.logger.log(event);
    this.keyEventSubject.next(event);
  }

  handleKeyDown(event) {
    switch (event.keyCode) {
      case 40:
        if (this.selectedIndex > this.dataList.length - 1) {
          this.selectedIndex = this.dataList.length - 1;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex++;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 38:
        if (this.selectedIndex < 1) {
          this.selectedIndex = 0;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex--;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 27:
        this.hideDropDown();
        break;
      case 13:
        this.onDataPicked(this.dataList[this.selectedIndex]);
        break;
    }
  }

  onScroll() {
    this.searchParams.set('offset', this.dataList.length.toString());
    this.apiService.getUsers(this.organizationId, this.searchParams).subscribe(
      response => {
        response.data.rows.forEach(item => {
          this.dataList.push(item)
        });
      },
      error => { }
    );
  }



  isItemSelected(item: any) {
    if (this.selectedDataList) {
      return this.selectedDataList.findIndex((element) => element['id'] === item['id']) > -1 ? true : false;
    }
    return false;
  }

  public colorArray = [
    "#85bb65",
    "#ee4f4f",
    "#eece4f",
    "#eeae4f",
    "#168eea",
    "#161eea",
    "#bb4f4f"
  ];

  getColor(data: any) {
    return this.colorArray[<number>(data['id'] % 8)];
  }

  isFunction(item) {
    if (typeof item === "function") {
      return true;
    }
    return false;
  }


  writeValue(value: any) {
    this.setSelectedUsers(value);
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  onDataSelected(selectedUsers: Array<any>) {
    this.onUserSelected.emit(selectedUsers);
    this.propagateChange(selectedUsers);
  }

  setSelectedUsers(selectedUsers: Array<any>) {
    if (
      Array.isArray(selectedUsers) &&
      selectedUsers &&
      selectedUsers.length > 0
    ) {
      let searchParams: URLSearchParams = new URLSearchParams();
      searchParams.set('id_In', this.getUserIDs(selectedUsers).toString());
      this.apiService.getUsers(this.organizationId, searchParams).subscribe(
        response => {
          if (Array.isArray(response.data)) {
            this.selectedDataList = response.data;
          } else {
            this.selectedDataList = [];
          }
        },
        error => {
          this.selectedDataList = [];
        }
      );
    } else {
      this.selectedDataList = [];
    }
  }

  getUserCodes(userList: Array<any>) {
    let codes = [];
    userList.forEach(user => {
      codes.push(user.userCode);
    });
    return codes;
  }

  getUserIDs(userList: Array<any>) {
    let IDs = [];
    userList.forEach(user => {
      IDs.push(user.id);
    });
    return IDs;
  }



  onSearchTextChanged(searchText) {

    this.searchParams = new URLSearchParams();
    this.searchParams.set('limit', this.limit.toString());
    this.searchParams.set('offset', 0 + '');
    this.searchParams.set('sortBy', 'firstName');
    this.searchParams.set('sortType', 'ASC');

    if (searchText) {
      this.searchParams.set(
        'firstName_Like',
        searchText
      );
    }
    // this.parameterHttpService.getUsers(this.searchParams)
    this.apiService.getUsers(this.organizationId, this.searchParams).subscribe(
      response => {
        if (Array.isArray(response.data)) {
          this.dataList = response.data;
        } else {
          this.dataList = [];
        }
      },
      error => {
        this.dataList = [];
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/user-dropdown/user-dropdown.component.ts